import { Component, Inject, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';


@Component({
  selector: 'app-fee-setting-dialog-box',
  templateUrl: './fee-setting-dialog-box.component.html',
  styleUrls: ['./fee-setting-dialog-box.component.scss']
})
export class FeeSettingDialogBoxComponent implements OnInit {

  feeSetting: FormGroup;
  FeetempSeetingDataSearchForm:FormGroup;
  sessionList: any[];
  SessionFilterList: any[];
  collegedataList: any;
  collegedataFilterList: any;
  feeModeList: any;
  filteredfeeModeList: any;
  onlineModeList: any;
  filteredonlineModeList: any;
  offlineModeList: any;
  filteredofflineModeList: any;
  FeeSettingList: any;
  OFFLIT: any;
  UserCollege: any;
  errMsg: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    public dialogRef2: MatDialogRef<FeeSettingDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,   public router: Router,  private httpClient: HttpClient,
   private spinner: NgxSpinnerService) { this.APIService = environment.serviceUrl;}
  list;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  purposeList: any;
  filteredpurposeList: any;
  cgList: any;
  filteredcgList: any;
  submitpayload: any;
  FeeHeadList: any;
  headList: any[];
  selectedValues = [];
  APIService: string;
  FeeHeadIddd: any;
  dialogRef: MatDialogRef<any>;
  userPermission: any;
  utp: string;
  feeSettingCreate=true;
feeSettingUpdate=true;
feeSettingDelete=true;
  ngOnInit(): void { 
    this.list = true;
    window.scroll(0, 0);
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
      if(element.PageName == 'Fee Mode' && element.PCreate == false)
      {
          this.feeSettingCreate = false;  
      }
      if(element.PageName == 'Fee Mode' && element.PUpdate == false)
      {
          this.feeSettingUpdate = false;  
      }   
      if(element.PageName == 'Fee Mode' && element.PDelete == false)
      {
          this.feeSettingDelete = false;  
      } 
    });
  }
    this.feeSetting = this.fb.group({
      Session: new FormControl ('',Validators.required),
      College: new FormControl ('',Validators.required),
     FeeMode: new FormControl ('',Validators.required),
     OnlineMode: new FormControl (''),
     OfflineMode: new FormControl (''),
    });

    this.FeetempSeetingDataSearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
    let idd ='';
    this.fetchSession(idd);
    // this.getCollegeData();
    this.fetchFeeeMode();
    this.getFeeSettingData();
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
     this.prepopulationForDelete(this.data.selected);
    } else {
      // alert(this.data.key) 
    }
  }

  addnewrecord(e){
    if (e === 'true'){
      this.list = false;
      this.editButton = false;
      this.submitButton = true;
      this.deleteButton = false;
       this.feeSetting.reset();
    } 
    else {
      this.list = true;
      this.editButton = true;
      this.submitButton = false;
      this.deleteButton = true;
        this.ngOnInit();
    }
  }

  fetchSession(id) {
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id; 
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    })
  }

  keypress() {
    this.umsService.searchFeeTempSetting(this.FeetempSeetingDataSearchForm.value).subscribe(
      (res) => {
        this.FeeSettingList = res.data;
      }, (ERROR: HttpErrorResponse) => {
        this.FeeSettingList = [];
      });
  }

  getCollegeData(id) {
    this.spinner.show();
     if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    const payload = {};
    payload['CgCode'] = this.UserCollege
    this.umsService.getCollege(payload).subscribe((res) => {
      this.collegedataList = res.data;
      this.collegedataFilterList = this.collegedataList.slice();
      this.spinner.hide();
    },(ERROR: HttpErrorResponse) => {
      this.collegedataList = [];
      this.spinner.hide();
    })
  }

  fetchFeeeMode() {
    const payload = {};
    payload['CdType'] = 'FMODE';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.feeModeList = res.data;
        this.filteredfeeModeList = this.feeModeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchOnlineMode() {
    const payload = {};
    payload['CdType'] = 'ONLIN';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.onlineModeList = res.data;
        this.filteredonlineModeList = this.onlineModeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchOfflineMode() {
    const payload = {};
    payload['CdType'] = 'OFFLI';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.offlineModeList = res.data;
        this.filteredofflineModeList = this.offlineModeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }




  save(){
    if(this.feeSetting.invalid){
      this.feeSetting.get('Session').markAsTouched();
      this.feeSetting.get('College').markAsTouched();
      this.feeSetting.get('FeeMode').markAsTouched();
    }else{
      this.submitFeeSetting();
    }
  }
  
  
   //old working
  // submitFeeSetting() {
  //   this.spinner.show();
  //   this.submitpayload = this.feeSetting.value;
  //   let iserror = false;
  //   var bar = new Promise<void>((resolve, reject) => {
  //     this.submitpayload.College.forEach((element, index, array) => {
  //       let arr1 = [];
  //       arr1.push(
  //         this.fb.group({
  //           FeeMode: new FormControl(this.submitpayload.FeeMode),
  //           OfflineMode: new FormControl(this.submitpayload.OfflineMode),
  //           OnlineMode: new FormControl(this.submitpayload.OnlineMode),
  //           Session: new FormControl(this.submitpayload.Session),
  //           College: new FormControl(element),
  //         })
  //       )
  //       this.umsService.addFeeSetting(arr1[0].value).subscribe(res => {
  //         this.spinner.hide();
  //         if (res.status == false) {
  //           iserror = true;
  //           this.errMsg = res.message
  //         }
  //         if (index === array.length - 1) resolve();
  //         else {
  //           iserror = false
  //           this.errMsg = res.message
  //           // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
  //         }
  //         if (res.status == true) {
  //           iserror = false
  //           this.errMsg = res.message
  //           // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
  //         }
  //       },
  //         (ERROR: HttpErrorResponse) => {
  //           this.spinner.hide();
  //           iserror = true;
  //           this.errMsg = ERROR.error.message
  //           if (index === array.length - 1) resolve();
  //         });
  //     });
  //   })
  //   bar.then(() => {
  //     if (iserror == false) {
  //       let data = {}
  //       data['message'] = "Submitted Successfully"
  //       data['title'] = 'Information'
  //       data['icon'] = 'fas fa-check'
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       this.dialogRef.afterClosed().subscribe((result) => {
  //         this.dialogRef2.close()
  //       });
  //     } else {
  //       let data = {}
  //       data['message'] = this.errMsg
  //       data['title'] = 'Alert'
  //       data['icon'] = 'fas fa-close'
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       this.ngOnInit();
  //     }
  //   });
  // }
 submitFeeSetting() {
  this.spinner.show();
  this.submitpayload = this.feeSetting.value;

  let iserror = false;
  let completed = 0;   

  var bar = new Promise<void>((resolve, reject) => {

    this.submitpayload.College.forEach((element, index, array) => {

      let arr1 = [];
      arr1.push(
        this.fb.group({
          FeeMode: new FormControl(this.submitpayload.FeeMode),
          OfflineMode: new FormControl(this.submitpayload.OfflineMode),
          OnlineMode: new FormControl(this.submitpayload.OnlineMode),
          Session: new FormControl(this.submitpayload.Session),
          College: new FormControl(element),
        })
      );

      this.umsService.addFeeSetting(arr1[0].value).subscribe(res => {

        if (res.status == false) {
          iserror = true;
          this.errMsg = res.message;
        } else {
          this.errMsg = res.message;
        }

        completed++; 

        if (completed === array.length) {
          this.spinner.hide();   
          resolve();
        }

      },
      (ERROR: HttpErrorResponse) => {

        iserror = true;
        this.errMsg = ERROR.error.message;

        completed++;  

        if (completed === array.length) {
          this.spinner.hide();  
          resolve();
        }
      });

    });
  });

  bar.then(() => {
    if (iserror == false) {
      let data = {};
      data['message'] = "Submitted Successfully";
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';

      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.dialogRef2.close();
      });

    } else {
      let data = {};
      data['message'] = this.errMsg;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';

      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
    }
  });
}

  
    update(){
      if(this.feeSetting.invalid){
        this.feeSetting.get('Session').markAsTouched();
        this.feeSetting.get('College').markAsTouched();
        this.feeSetting.get('FeeMode').markAsTouched();
      }else{
        this.deleteupdate(this.feeSetting.value);
      }
    }

  deleteupdate(id) {
    this.spinner.show();
    // const commaSeparatedString = id.Colleges.join(", ");
    let formattedString = id.College.map(item => `'${item}'`).join(', ');
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        FeeMode: id.FeeMode,
        OfflineMode: id.OfflineMode,
        OnlineMode: id.OnlineMode,
        Session: id.Session,
        College: formattedString,
        FeeSetId: this.FeeHeadIddd
      },
    };
    this.httpClient.delete(this.APIService + '/fees/feeset', options)
      .subscribe((s) => {
        this.spinner.hide();
        this.updateFeeSetting();
        // this.spinner.hide();
        // let cc = [];
        // cc.push(s);
        // let  data = {}
        // data['message'] = cc[0].message
        // data['title'] = 'Information'
        // data['icon'] = 'fas fa-check'
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.dialogRef2.close();
        // });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        // let data = {}
        // data['message'] = ERROR.error.message
        // data['title'] = 'Alert'
        // data['icon'] = 'fas fa-close'
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);

      });

  }


  updateFeeSetting() {
  this.spinner.show();
  this.submitpayload = this.feeSetting.value;

  let iserror = false;
  let completed = 0;   

  var bar = new Promise<void>((resolve, reject) => {

    this.submitpayload.College.forEach((element, index, array) => {

      let arr1 = [];
      arr1.push(
        this.fb.group({
          FeeMode: new FormControl(this.submitpayload.FeeMode),
          OfflineMode: new FormControl(this.submitpayload.OfflineMode),
          OnlineMode: new FormControl(this.submitpayload.OnlineMode),
          Session: new FormControl(this.submitpayload.Session),
          College: new FormControl(element),
        })
      );

      this.umsService.addFeeSetting(arr1[0].value).subscribe(res => {

        if (res.status == false) {
          iserror = true;
          this.errMsg = res.message;
        } else {
          this.errMsg = res.message;
        }

        completed++;

        if (completed === array.length) {
          this.spinner.hide(); 
          resolve();
        }

      },
      (ERROR: HttpErrorResponse) => {

        iserror = true;
        this.errMsg = ERROR.error.message;

        completed++; 

        if (completed === array.length) {
          this.spinner.hide();  
          resolve();
        }
      });

    });
  });

  bar.then(() => {
    if (iserror == false) {
      let data = {};
      data['message'] = "Updated Successfully";
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';

      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.dialogRef2.close();
      });

    } else {
      let data = {};
      data['message'] = this.errMsg;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';

      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
    }
  });
}
   //old working 
  // updateFeeSetting() {
  //   this.spinner.show();
  //   this.submitpayload = this.feeSetting.value;
  //   let iserror = false;
  //   var bar = new Promise<void>((resolve, reject) => {
  //     this.submitpayload.College.forEach((element, index, array) => {
  //       let arr1 = [];
  //       arr1.push(
  //         this.fb.group({
  //           FeeMode: new FormControl(this.submitpayload.FeeMode),
  //           OfflineMode: new FormControl(this.submitpayload.OfflineMode),
  //           OnlineMode: new FormControl(this.submitpayload.OnlineMode),
  //           Session: new FormControl(this.submitpayload.Session),
  //           College: new FormControl(element),
  //         })
  //       )
  //       this.umsService.addFeeSetting(arr1[0].value).subscribe(res => {
  //         this.spinner.hide();
  //         if (res.status == false) {
  //           iserror = true;
  //           this.errMsg = res.message
  //         }
  //         if (index === array.length - 1) resolve();
  //         else {
  //           iserror = false
  //           this.errMsg = res.message
  //           // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
  //         }
  //         if (res.status == true) {
  //           iserror = false
  //           this.errMsg = res.message
  //           // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
  //         }
  //       },
  //         (ERROR: HttpErrorResponse) => {
  //           this.spinner.hide();
  //           iserror = true;
  //           this.errMsg = ERROR.error.message
  //           if (index === array.length - 1) resolve();
  //         });
  //     });
  //   })
  //   bar.then(() => {
  //     if (iserror == false) {
  //       let data = {}
  //       data['message'] = "Updated Successfully"
  //       data['title'] = 'Information'
  //       data['icon'] = 'fas fa-check'
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       this.dialogRef.afterClosed().subscribe((result) => {
  //         this.dialogRef2.close()
  //       });
  //     } else {
  //       let data = {}
  //       data['message'] = this.errMsg
  //       data['title'] = 'Alert'
  //       data['icon'] = 'fas fa-close'
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       this.ngOnInit();
  //     }
  //   });


  // }
    
    // updateFeeSetting() {
    //   this.spinner.show();
    //   this.submitpayload = this.feeSetting.value;
    //  this.submitpayload['FeeSetId'] = this.FeeHeadIddd;
    //   this.umsService.updateFeeSetting(this.submitpayload).subscribe(res => {
    //     this.spinner.hide();
    //     if (res.status){
    //       let  data = {}
    //       data['message'] = res.message
    //       data['title'] = 'Information'
    //       data['icon'] = 'fas fa-check'
    //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //        // this.dialogRef.afterClosed().subscribe(result => {
    //       //   this.ngOnInit();
    //       // });
    //     } else {
    //       this.spinner.hide();
    //       let  data = {}
    //       data['message'] = res.message
    //       data['title'] = 'Information'
    //       data['icon'] = 'fas fa-close'
    //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //        // this.dialogRef.afterClosed().subscribe(result => {
    //       //   this.ngOnInit();
    //       // });
    //     }
    //   },(ERROR: HttpErrorResponse) => {
    //     let  data = {}
    //     this.spinner.hide();
    //     data['message'] = ERROR.error.message
    //     data['title'] = 'Information'
    //     data['icon'] = 'fas fa-check'
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      
    //  });
    // }
    
    editdata(e, k) {
      if (e === 'true') {
        this.list = false;
        this.prepopulation(k);
      } else {
        this.list = true;
      }
    }
    
    getFeeSettingData() {
      this.spinner.show();
        const payload = {};
        this.umsService.getFeeSetting(payload).subscribe(res => {
        this.FeeSettingList = res.data;
        this.spinner.hide();
            });
        }
      
    
    prepopulation(id) {
      this.spinner.show();
      const payload = {};
      payload['FeeSetId'] = id.FeeSetId;
      this.FeeHeadIddd =  id.FeeSetId;
      
      this.umsService.getFeeSetting(payload).subscribe((res) => {
        this.spinner.hide();
        let data = res.data[0];
        let cgValue = id.College.split(',');
        this.getCollegeData(data.Session);
        if (res.status) { 
          this.editButton = true;
          this.submitButton = false;
          this.deleteButton = false;
          this.feeSetting = this.fb.group({
            Session: new FormControl(data.Session, [Validators.required]),
            College: new FormControl(cgValue, [Validators.required]),
            FeeMode: new FormControl(data.FeeMode, [Validators.required]),
            OnlineMode: new FormControl(data.OnlineMode),
            OfflineMode: new FormControl(data.OfflineMode),
          });
    
        } else {
          // this.umsService.openSnackbar(res.message);
        }
      });
    }
    
    deletedata(e, k) {
  if (e === 'true') {
    this.list = false;
    this.prepopulationForDelete(k);
  } else {
    this.list = true;
  }
}

prepopulationForDelete(id) {
  this.spinner.show();
  const payload = {};
  payload['FeeSetId'] = id.FeeSetId;
  this.FeeHeadIddd =  id.FeeSetId;
  this.umsService.getFeeSetting(payload).subscribe((res) => {
    this.spinner.hide();
        let data = res.data[0];
        let cgValue = id.College.split(',');
        this.getCollegeData(data.Session);
        if (res.status) { 
          this.editButton = false;
          this.submitButton = false;
          this.deleteButton = true;
          this.feeSetting = this.fb.group({
            Session: new FormControl(data.Session, [Validators.required]),
            College: new FormControl(cgValue, [Validators.required]),
            FeeMode: new FormControl(data.FeeMode, [Validators.required]),
            OnlineMode: new FormControl(data.OnlineMode),
            OfflineMode: new FormControl(data.OfflineMode),
          });
    
        } else {
          // this.umsService.openSnackbar(res.message);
        }
      });
}

DeletetheRecord(){
  const  data = {};
  data['message'] = 'Are You Sure You Want To Delete This Record ?';
  data['title'] = 'Alert';
  data['icon'] = 'fa fa-question';
  this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
  this.dialogRef.afterClosed().subscribe(result => {
    if (result === 'yes'){
      this.delete(this.feeSetting.value);
      this.dialogRef2.close();
    }else{
     // this.ngOnInit();
     this.dialogRef2.close();
    }
  });
 }


 delete(id){
  this.spinner.show();
  const options = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),  body: {
    Session: id.Session,
    College: id.College,
    FeeMode: id.FeeMode,
    OnlineMode: id.OnlineMode,
    OfflineMode: id.OfflineMode,
    FeeSetId: this.FeeHeadIddd
  },
};
  this.httpClient.delete(this.APIService + '/fees/feeset', options)
  .subscribe((s) => {
    this.spinner.hide();
    // this.spinner.hide();
    let cc = [];
    cc.push(s);
    let  data = {}
    data['message'] = cc[0].message
    data['title'] = 'Information'
    data['icon'] = 'fas fa-check'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  },(ERROR: HttpErrorResponse) => {
    this.spinner.hide();
    let  data = {}
    data['message'] = ERROR.error.message
    data['title'] = 'Alert'
    data['icon'] = 'fas fa-close'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.ngOnInit();
    // this.umsService.openSnackbar(ERROR.error.message);

 });

 }

 onFilteredReturn(filteredData: any[]): void {
  this.collegedataFilterList = filteredData;
  // Ensure selected values are included in the filtered list
  this.collegedataFilterList = [
    ...this.collegedataFilterList,
    ...this.collegedataList.filter((item) =>
      this.selectedValues.includes(item.CgCode)
    )
  ];
}

onSelectionChange(event): void {
  this.selectedValues = event.value;
}
toggleSelectAll() {
  const control = this.feeSetting.get('College');
  const allValues = this.collegedataFilterList.map(x => x.CgCode);
  const selected = (control?.value || []).filter((v: string) => v !== '__select_all__');

  if (selected.length === allValues.length) {
    control?.setValue([]);
  } else {
    control?.setValue(allValues);
  }
}
}

  
